export default __webpack_public_path__ + "static/media/icon-add-black.78097ec6.svg";